import { getSessionToken } from "../../../hooks/useSession.js";

const API_BASE = import.meta.env.VITE_API_URL || "http://localhost:4000";

export interface EmailTemplate {
  id: string;
  name: string;
  subject: string;
  html: string;
}

/** One call to the admin inbox API; throws with the server's message on failure. */
export async function inboxRequest<T>(path: string, init: RequestInit = {}): Promise<T> {
  const response = await fetch(`${API_BASE}/api/admin/inbox${path}`, {
    ...init,
    headers: {
      Authorization: `Bearer ${getSessionToken()}`,
      ...(init.body ? { "Content-Type": "application/json" } : {}),
      ...init.headers,
    },
  });
  const json = await response.json().catch(() => null);
  if (!response.ok || !json?.success) {
    throw new Error(json?.error || "Something went wrong. Try again.");
  }
  return json.data as T;
}

/** Signature block placed under the message, set off the way mail clients do. */
export function signatureBlock(html: string): string {
  return html ? `<p>--</p>${html}` : "";
}
